import { useState } from 'react';
import { Link } from 'react-router-dom';
import PanelLayout from '../components/PanelLayout';
import { newOpportunities } from '@/mocks/therapistPanel';

export default function FirsatlarPage() {
  const [favorites, setFavorites] = useState<number[]>([]);
  const [hidden, setHidden] = useState<number[]>([]);

  const toggleFav = (id: number) => {
    setFavorites((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleHide = (id: number) => {
    setHidden((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const visible = newOpportunities.filter((o) => !hidden.includes(o.id));

  return (
    <PanelLayout>
      <div className="max-w-6xl mx-auto">
        <div className="mb-6">
          <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500">İşletme Fırsatları</h1>
          <p className="text-sm text-gray-500 mt-1">
            Profilinize uygun spa ve wellness işletmelerini keşfedin. İşletme adı, telefon ve adres gizli kalır.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {visible.map((opp) => (
            <div key={opp.id} className="bg-white rounded-xl border border-gray-100 p-5 flex flex-col">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-deep-navy-500">{opp.spaType}</span>
                  {opp.verified && (
                    <span className="w-4 h-4 flex items-center justify-center text-dark-teal-500" title="Doğrulanmış">
                      <i className="ri-verified-badge-fill text-xs" />
                    </span>
                  )}
                </div>
                <button
                  onClick={() => toggleFav(opp.id)}
                  className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <span className={`w-5 h-5 flex items-center justify-center ${favorites.includes(opp.id) ? 'text-red-500' : 'text-gray-300'}`}>
                    <i className="ri-heart-3-fill text-lg" />
                  </span>
                </button>
              </div>

              <div className="space-y-1.5 mb-4 flex-1">
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-map-pin-line" /></span>
                  {opp.city}
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-time-line" /></span>
                  {opp.workModel}
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-money-cny-circle-line" /></span>
                  {opp.salaryBand}
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-shield-check-line" /></span>
                  SGK: {opp.ssg}
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-hotel-bed-line" /></span>
                  Konaklama: {opp.accommodation}
                </div>
                <div className="flex items-center gap-2 text-xs text-dark-teal-500 font-medium">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-star-line" /></span>
                  {opp.expertise}
                </div>
              </div>

              {/* Hidden info placeholder */}
              <div className="bg-gray-50 rounded-lg p-3 mb-4">
                <p className="text-[10px] text-gray-400 uppercase tracking-wider font-medium mb-1.5">İletişim bilgileri gizli</p>
                <div className="space-y-1">
                  <div className="h-2 bg-gray-200 rounded w-3/4" />
                  <div className="h-2 bg-gray-200 rounded w-1/2" />
                  <div className="h-2 bg-gray-200 rounded w-2/3" />
                </div>
              </div>

              <div className="flex gap-2">
                <button className="flex-1 px-3 py-2 rounded-lg bg-dark-teal-500 text-white text-xs font-semibold hover:bg-dark-teal-600 transition-colors cursor-pointer">
                  İş Başvurusunda Bulun
                </button>
                <button
                  onClick={() => toggleHide(opp.id)}
                  className="px-3 py-2 rounded-lg bg-gray-100 text-gray-600 text-xs font-medium hover:bg-gray-200 transition-colors cursor-pointer"
                >
                  Gizle
                </button>
              </div>
            </div>
          ))}
        </div>

        {visible.length === 0 && (
          <div className="text-center py-16">
            <span className="w-12 h-12 flex items-center justify-center mx-auto text-gray-300 mb-3">
              <i className="ri-briefcase-line text-3xl" />
            </span>
            <p className="text-sm text-gray-500">Tüm fırsatları gizlediniz.</p>
            <button
              onClick={() => setHidden([])}
              className="mt-2 text-xs text-dark-teal-500 font-medium hover:underline cursor-pointer"
            >
              Tümünü göster
            </button>
          </div>
        )}
      </div>
    </PanelLayout>
  );
}